import styled from 'styled-components'
import homeImg from '../assets/home.png'
import categoryImg from '../assets/category.png'
import exampleRaumImg from '../assets/exampleRaum.png'
import exampleFloorImg from '../assets/exampleFloor.png'
import locationImg from '../assets/location2.png'
import catalogImg from '../assets/catalog2.png'
import downloadImg from '../assets/download.png'
import solomonImg from '../assets/solomon2.png'
import { useNavigate, useLocation } from 'react-router-dom'
import { getCookie,setCookie } from '../utils/cookie'
import { handleCatalogTabClick } from '../utils/catalogTab'
function BottomBarPc() {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <MainContainer>
      <>
      <Row>
        {/*
        <Column
          onClick={() => {
            if (location.pathname.indexOf('category') > -1) return false
            navigate(`/category/${getCookie('selectedCategory')}`)
          }}
        >
          <Img src={categoryImg} />
          <Text>메뉴</Text>
        </Column>
        */}
        <Column
          onClick={() => {
            if (location.pathname === '/catalog') return false
            navigate('/catalog')
          }}
        >
          <Img src={solomonImg} />
          <Text>About</Text>
          {/*<SubText>About</SubText>*/}
        </Column>
        
        <Column
          onClick={() => {
            setCookie('selectedCategory', 1);
            navigate(`/case/1`)
          }}
        >
          <Img src={exampleFloorImg} />
          <Text>마루 시공사례</Text>
          {/*<SubText>Flooring Gallery</SubText>*/}
        </Column>
        
        <Column
          onClick={() => {
            setCookie('selectedCategory', 2);
            navigate(`/case/2`)
          }}
        >
          <Img src={exampleRaumImg} />
          <Text>라움 시공사례</Text>
          {/*<SubText>Raum Gallery</SubText>*/}
        </Column>
        {/*
        <Column
          onClick={() => {
            if (location.pathname.indexOf('case') > -1) return false
            navigate(`/case/${getCookie('selectedCategory')}`)
          }}
        >
          <Img src={exampleImg} />
          <Text>시공사례</Text>
        </Column>
        */}

        <Column
          onClick={() => handleCatalogTabClick(navigate, location.pathname)}
        >
          <Img src={catalogImg} />
          <Text>카탈로그</Text>
          {/*<SubText>Catalog</SubText>*/}
        </Column>
        <Column
          onClick={() => {
            window.open('http://www.eagonstore.com/shop/eagonShopList.do', '_blank')
          }}
        >
          <Img src={locationImg} />
          <Text>대리점검색</Text>
          {/*<SubText>Store</SubText>*/}
        </Column>

        {(() => {
         if (false) {
        <Column 
          onClick={() => {
            if (location.pathname.indexOf('home') > -1) return false
            navigate('/home')
          }}
        >
          <Img src={homeImg} />
          <Text>홈</Text>
        </Column>
        }
      })()}
      </Row>
      </>
    </MainContainer>
  )
}

export default BottomBarPc

const MainContainer = styled.div`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100vw;
  height: 102px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  z-index: 1000;
  overflow: visible !important;
`
const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: center;
  margin-left: 19.4px;
  margin-right: 19.4px;
  gap: 100px;
`
const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
`
const Img = styled.img`
  height: 32px;
`
const SubText = styled.p`
  font-family: Noto Sans KR;
  font-weight: bold;
  font-size: 15px;
  color: #9b9b9b;
  word-break: keep-all;
`

const Text = styled.p`
  font-family: Noto Sans KR;
  font-weight: bold;
  font-size: 20px;
  color:##2F2D2E;
  word-break: keep-all;
`
const DownloadImg = styled.img`
  position: absolute;
  height: 46px;
  margin-top: -50px;
`
